var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.521)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 52,10 88,0 a 12 12 0 0 1 12,12 l 0,148 a 12,12 0 0 1 -12,12 l -88,0 a 12,12 0 0 1 -12,-12 l 0,-148 a 12,12 0 0 1 12,-12 z m 6,20 a 12 12 0 0 0 -12,12 l 0,108 a 12 12 0 0 0 12,12 l 76,0 a 12,12 0 0 0 12,-12 l 0,-108 a 12,12 0 0 0 -12,-12 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCell);
export default __webpack_public_path__ + "static/media/cell.6ec365b6abbb3ee1fcdfe7fcad8e4755.svg";
export { ForwardRef as ReactComponent };